import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
var requests = require("@/utils/requests").default;
export default {
  data: function data() {
    return {
      imageDialog: {
        visible: false,
        url: ''
      }
    };
  },
  methods: {
    save_attachments: function save_attachments(list, app, model, id) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(list && list[0])) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return _this.uploadAttachment("last", list, id, app, model);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    uploadAttachment: function uploadAttachment(whichOne, files, recordId) {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var app, model, all, count, total;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              app = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : 'act';
              model = _arguments.length > 4 && _arguments[4] !== undefined ? _arguments[4] : 'task';
              _this2.attachment.loading = true;
              if (_this2.files_available) {
                _this2.files_available = false;
              }
              if (!files) {
                files = _this2.$refs.inputUpload.uploadFiles;
              } else {}
              all = Object.keys(files);
              if (whichOne == "last") {
                all = [Object.keys(files).pop()];
              }
              if (!recordId) {
                recordId = _this2.record_id;
              }
              count = 1;
              total = all.length;
              new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return all.forEach( /*#__PURE__*/function () {
                          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(key) {
                            var f, fd, filename, rtn, text;
                            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                              while (1) switch (_context2.prev = _context2.next) {
                                case 0:
                                  f = files[key];
                                  fd = new FormData();
                                  if (f.raw) {
                                    fd.append('file', f.raw, f.name);
                                  } else {
                                    filename = f.name ? f.name : "file.png";
                                    fd.append('file', f, filename);
                                  }
                                  fd.append('record_id', recordId);
                                  fd.append('attachment_id', '');
                                  _this2.saving = true;
                                  _context2.next = 8;
                                  return requests.upload_attachments({
                                    files: fd,
                                    record_id: recordId,
                                    app: app,
                                    model: model
                                  });
                                case 8:
                                  rtn = _context2.sent;
                                  _this2.saving = false;
                                  text = "";
                                  if (!(rtn.status == "Success")) {
                                    _context2.next = 24;
                                    break;
                                  }
                                  if (rtn.text) {
                                    text = rtn.text;
                                  } else {
                                    text = _this2.$t("The file has been successfully saved.");
                                  }
                                  if (!(count == total)) {
                                    _context2.next = 21;
                                    break;
                                  }
                                  _this2.attachment.loading = false;
                                  _this2.$store.state.response_alert = {
                                    name: "Kullanıcı",
                                    title: _this2.$t("Congratulations"),
                                    text: text,
                                    status: true,
                                    modal: true,
                                    class: "success"
                                  };
                                  resolve(true);
                                  _context2.next = 19;
                                  return _this2.getAttachments(recordId, app, model);
                                case 19:
                                  _this2.modal_key = "k" + Math.random(1, 9999);
                                  if (typeof _this2.fieldVisible != "undefined") {
                                    _this2.fieldVisible.documents = false;
                                  }
                                case 21:
                                  delete files[0];
                                  _context2.next = 27;
                                  break;
                                case 24:
                                  if (count == total) {
                                    reject(true);
                                    _this2.attachment.loading = false;
                                  }
                                  if (rtn.text) {
                                    text = rtn.text;
                                    if (rtn.err) {
                                      text = text + rtn.err;
                                    }
                                  } else {
                                    text = _this2.$t("An error occurred while saving the file.");
                                  }
                                  _this2.$store.state.response_alert = {
                                    name: "Kullanıcı",
                                    title: _this2.$t("Christ no!"),
                                    text: text,
                                    status: true,
                                    modal: true,
                                    class: "warning"
                                  };
                                case 27:
                                  count++;
                                case 28:
                                case "end":
                                  return _context2.stop();
                              }
                            }, _callee2);
                          }));
                          return function (_x3) {
                            return _ref2.apply(this, arguments);
                          };
                        }());
                      case 2:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getAttachments: function getAttachments(id, app, model) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var search, attachments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              search = {
                record_id: id,
                model: model,
                app: app
              };
              _context5.next = 3;
              return requests.get_attachments(search);
            case 3:
              attachments = _context5.sent;
              _this3.attachments = attachments ? attachments.records : [];
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    deleteAttachment: function deleteAttachment(attachment_id, record_id, app, model) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this4.$confirm(_this4.$t('This will permanently delete the file'), _this4.$t('Warning'), {
                confirmButtonText: _this4.$t('OK_Delete'),
                cancelButtonText: _this4.$t('Cancel_Delete'),
                type: 'warning'
              }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                var rtn;
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return requests.delete_attachment({
                        attachment_id: attachment_id,
                        record_id: record_id,
                        model: model,
                        app: app
                      });
                    case 2:
                      rtn = _context6.sent;
                      _this4.getAttachments(record_id, app, model);
                      _this4.$message({
                        type: 'success',
                        message: _this4.$t('Delete completed')
                      });
                    case 5:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }))).catch(function () {
                _this4.$message({
                  type: 'info',
                  message: _this4.$t('Delete canceled')
                });
              });
              // this.is_delete_attachment = false;
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    optimizeFileName: function optimizeFileName(file) {
      if (file.length > 33) {
        var first = file.substr(0, 20);
        var last = file.substr(-10, 10);
        var newFile = first + "..." + last;
        return newFile;
      }
      return file;
    },
    removeAttachment: function removeAttachment(f) {
      Object.assign(f, {
        name: ""
      });
    },
    isImage: function isImage(att) {
      return att.mime_type && att.mime_type.substring(0, 5) == 'image' ? true : false;
    },
    isImageType: function isImageType(att) {
      var nm = att && att.name ? att.name.split(".") : '';
      var t = nm.length - 1;
      if (nm[t]) {
        att.type = nm[t];
      }
      return att && att.type && (att.type == 'jpg' || att.type == 'bmp' || att.type == 'png' || att.type == 'jpeg' || att.type == 'gif') ? true : false;
    },
    imageDialogOpen: function imageDialogOpen(att) {
      this.imageDialog.url = this.getImageUrl(att);
      this.imageDialog.visible = true;
    },
    getImageUrl: function getImageUrl(att, record_id) {
      if (!att.file_id && att.id) {
        att.file_id = att.id;
      }
      return "".concat(this.$kvAttachmentViewPath, "?app=dm&model=document&record_id=") + record_id + '&file_name=' + att.name + '&file_type=' + att.file_type + '&uid=' + att.file_id + '&_blank=1&_csrf=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOjI5MzI0LCJleHAiOjE1ODQ1MDA4Mjl9.Hb-ptWmjnoDhg7sGkXa2PDjJQ-K0UpoU6fjVEi7MAh4';
    },
    getAttachmentUrl: function getAttachmentUrl(att) {
      if (!att.file_id && att.id) {
        att.file_id = att.id;
      }
      return "".concat(this.$kvAttachmentViewPath, "?app=") + att.app + "&model=" + att.model + "&record_id=" + att.record_id + '&file_name=' + att.name + '&file_type=' + att.file_type + '&uid=' + att.file_id + '&_blank=1&_csrf=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOjI5MzI0LCJleHAiOjE1ODQ1MDA4Mjl9.Hb-ptWmjnoDhg7sGkXa2PDjJQ-K0UpoU6fjVEi7MAh4';
    },
    openFileUrl: function openFileUrl(att, record_id) {
      var model = att.model ? att.model : this.model;
      var app = att.app ? att.app : this.app;
      if (!att.file_id && att.id) {
        att.file_id = att.id;
      }
      var nm = att && att.name ? att.name.split(".") : '';
      var t = nm.length - 1;
      if (nm[t]) {
        att.file_type = nm[t];
      }
      var r = "".concat(this.$kvAttachmentViewPath, "?app=") + app + "&model=" + model + "&record_id=" + record_id + '&file_name=' + att.name + '&file_type=' + att.file_type + '&uid=' + att.file_id + '&_blank=1&_csrf=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOjI5MzI0LCJleHAiOjE1ODQ1MDA4Mjl9.Hb-ptWmjnoDhg7sGkXa2PDjJQ-K0UpoU6fjVEi7MAh4';
      window.open(r);
    },
    getFileIcon: function getFileIcon(att, design, size) {
      console.log("getFileIcon", att, design, size);
      var nm = att && att.name ? att.name.split(".") : '';
      if (!att.file_type && att.type) {
        att.file_type = att.type;
      }
      if (!att.file_id && att.id) {
        att.file_id = att.id;
      }
      var t = nm.length - 1;
      if (nm[t] || att.mime_type) {
        att.file_type = nm[t];
        if (nm[t] == "txt" || att.mime_type == "text/plain") {
          att.show_format = "iframe";
          return "kv-icon-f-text";
        }
        if (nm[t] == "pdf" || att.mime_type == "application/pdf") {
          att.show_format = "iframe";
          return "kv-icon-f-pdf";
        }
        if (nm[t] == "docx" || nm[t] == "doc") {
          att.show_format = "iframe";
          return 'kv-icon-f-word';
        }
        if (nm[t] == "ppt" || nm[t] == "pptx") {
          att.show_format = "iframe";
          return "kv-icon-f-powerpoint";
        }
        if (nm[t] == "xls" || nm[t] == "xlsx") {
          att.show_format = "iframe";
          return "kv-icon-f-excel";
        }
        if (nm[t] == "zip" || nm[t] == "tar" || nm[t] == "rar" || att.mime_type == "application/zip" || att.mime_type == "application/rar") {
          att.show_format = "iframe";
          return "kv-icon-f-file";
        }
        if (nm[t] == "csv") {
          att.show_format = "iframe";
          return "kv-icon-f-file";
        }
        if (nm[t] == "mp4" || nm[t] == "webm" || nm[t] == "mpeg" || nm[t] == "avi" || nm[t] == "wmv" || nm[t] == "mov" || nm[t] == "flv") {
          att.show_format = "iframe";
          return "kv-icon-f-camera";
        }
        if (nm[t] == "jpeg" || nm[t] == "jpg" || nm[t] == "png" || nm[t] == "gif" || nm[t] == "tiff" || nm[t] == "svg+xml" || nm[t] == "pjpeg" || nm[t] == "heif" || nm[t] == "heic" || nm[t] == "vnd.dwg") {
          att.show_format = "iframe";
          return 'kv-icon-f-image';
        } else if (nm[t] == "msword" || nm[t] == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || nm[t] == "application/vnd.ms-word.document.macroenabled.12") {
          att.show_format = "iframe";
          return 'kv-icon-f-word';
        } else if (nm[t] == "csv" || nm[t] == "html" || nm[t] == "plain" || nm[t] == "xml" || nm[t] == "rtf") {
          att.show_format = "iframe";
          return 'kv-icon-f-file';
        } else if (nm[t] == "csv" || nm[t] == "html" || nm[t] == "plain" || nm[t] == "xml" || nm[t] == "rtf" || nm[t] == "json" || nm[t] == "x-udf-image") {
          att.show_format = "iframe";
          return 'kv-icon-f-code';
        }
      }
    }
  }
};